import { AxiosError } from 'axios'

import { logout } from '../api/client/auth'
import type { IProfileData } from '../types/api/auth.d'
import { deleteCookieByName } from './cookies'
import { isBrowser } from './isBrowser'
import { storage } from './storage'

export const setLoggedUserData = (data: IProfileData) => ({
  id: data.id,
  first_name: data.firstName,
  last_name: data.lastName,
  email: data.email,
  confirmEmail: data.email,
  city: data?.city || '',
  country: data?.countryId || '',
  phone: data?.phone || '',
  street_address: data?.streetAddress || '',
  state: data?.stateId || '',
  zip: data?.zipCode || '',
})

interface LogoutUserParams {
  onLogoutSuccess?: () => void
  onLogoutError?: (error: AxiosError) => void
  setIsLogged?: (isLogged: boolean) => void
}

export const logoutUser = async ({
  onLogoutSuccess,
  onLogoutError,
  setIsLogged,
}: LogoutUserParams) => {
  try {
    await logout()
    onLogoutSuccess && onLogoutSuccess()
    storage.removeItem('user_data')
    if (isBrowser) {
      setIsLogged && setIsLogged(false)
      deleteCookieByName('X-TF-ECOMMERCE')
      if (typeof document !== 'undefined') {
        const event = new window.CustomEvent('tf-logout')
        document.dispatchEvent(event)
      }
    }
  } catch (e) {
    onLogoutError && onLogoutError(e as AxiosError)
  }
}
